import type { CompositionSlice } from '../../functions/calculations/portfolioCompositionData';
import { formatCompactCurrency } from '../../functions/calculations';
import { useFilter } from '../../contexts/FilterContext';
import { useCompositionChartColors } from './compositionChartColors';

interface PortfolioCompositionBarsProps {
  slices: CompositionSlice[];
  loading?: boolean;
}

export function PortfolioCompositionBars({ slices, loading }: PortfolioCompositionBarsProps) {
  const chartColors = useCompositionChartColors();
  const { selectedCurrency } = useFilter();
  const currencyCode = selectedCurrency?.currency || 'USD';

  if (loading) {
    return (
      <div className="composition-bars composition-bars--empty">
        <p>Loading composition…</p>
      </div>
    );
  }

  if (slices.length === 0) {
    return (
      <div className="composition-bars composition-bars--empty">
        <p>No portfolio data available</p>
      </div>
    );
  }

  return (
    <div className={`composition-bars${slices.length < 3 ? ' composition-bars--compact' : ''}`}>
      {slices.map((slice, index) => (
        <div className="composition-bar-row" key={`${slice.name}-${slice.country ?? ''}`}>
          <div className="composition-bar-row__header">
            <div className="composition-bar-row__label-group">
              <span className="composition-bar-row__label">{slice.name}</span>
              {slice.country && (
                <span className="composition-bar-row__country">{slice.country}</span>
              )}
            </div>
            <span className="composition-bar-row__metrics">
              <span className="composition-bar-row__value">
                {formatCompactCurrency(slice.value, currencyCode)}
              </span>
              <span className="composition-bar-row__pct">{Math.round(slice.percentage)}%</span>
            </span>
          </div>
          <div className="composition-bar-row__track">
            <div
              className="composition-bar-row__fill"
              style={{
                width: `${Math.max(slice.percentage, 0)}%`,
                backgroundColor: chartColors[index % chartColors.length],
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
